import { render, staticRenderFns } from "./PotentialFinancialImpactsSkeleton.vue?vue&type=template&id=ef7c63c6"
import script from "./PotentialFinancialImpactsSkeleton.vue?vue&type=script&lang=js"
export * from "./PotentialFinancialImpactsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports